import { useCarousel } from "nuka-carousel";
import { defineMessages } from "react-intl";

import { useFormatMessage } from "../../../Intl/Context";
import Button from "../../../Buttons/Button";
import Icon from "../../../Utils/Icon";

const ContributionsDatavizThemesCarouselArrows = () => {
  const { goBack, goForward } = useCarousel();

  const t = useFormatMessage();
  const previousSlideLabel = t(intlMessages.previousSlideLabel);
  const nextSlideLabel = t(intlMessages.nextSlideLabel);

  return (
    <div className="contributions-dataviz-themes-carousel-arrows">
      <Button
        type="button"
        id="contributions-dataviz-themes-carousel-previous-button"
        onClick={goBack}
        className="btn btn-unstyled btn-shadow-hover-none slider-control-previous"
        aria-label={previousSlideLabel}
        refocusAfterRender
      >
        <Icon className="fa fa-chevron-left align-middle" />
      </Button>

      <Button
        type="button"
        id="contributions-dataviz-themes-carousel-next-button"
        onClick={goForward}
        className="btn btn-unstyled btn-shadow-hover-none slider-control-next"
        aria-label={nextSlideLabel}
        refocusAfterRender
      >
        <Icon className="fa fa-chevron-right align-middle" />
      </Button>
    </div>
  );
};

export default ContributionsDatavizThemesCarouselArrows;

const intlMessages = defineMessages({
  previousSlideLabel: {
    id: "participativeModule.contributionsDataviz.themesCarousel.previousSlideLabel",
    defaultMessage: "Aller à la thématique précédente"
  },
  nextSlideLabel: {
    id: "participativeModule.contributionsDataviz.themesCarousel.nextSlideLabel",
    defaultMessage: "Aller à la thématique suivante"
  }
});
